'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-1';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0ee';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm176 88c0-4.4 3.6-8 8-8l48 0 0-160-24 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 168 48 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-112 0c-4.4 0-8-3.6-8-8z', 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM224 160c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0 0 160-48 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l112 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-48 0 0-168c0-4.4-3.6-8-8-8l-32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle1 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;